(function() {
  document.querySelectorAll('.brand-values').forEach(function(section) {
    var sectionId = section.dataset.sectionId;
    var tabs = section.querySelectorAll('.brand-values__tab');
    var imgs = section.querySelectorAll('.brand-values__img');
    var body = document.getElementById('brand-values-body-' + sectionId);

    function activate(index) {
      tabs.forEach(function(t) { t.classList.remove('active'); });
      imgs.forEach(function(img) { img.classList.remove('active'); });
      tabs[index].classList.add('active');
      if (imgs[index]) imgs[index].classList.add('active');
      if (body) body.textContent = tabs[index].dataset.body;
    }

    tabs.forEach(function(tab) {
      tab.addEventListener('mouseenter', function() {
        activate(parseInt(tab.dataset.index));
      });
      tab.addEventListener('click', function() {
        activate(parseInt(tab.dataset.index));
      });
    });
  });
})();